import React from "react";
import { isArray } from "lodash";

import { dateTime } from "../../../helpers/date";
import DetailItem from "./Helper";
import Link from "../../../components/Link";
import PurchaseButton from "./PurchaseButton";

import style from "./style.module.css";

export default function Item(props) {
    const {
        isbn = "",
        pages = "",
        format = "",
        dimension = "",
        publisher = "",
        available = [],
        author_name = "",
        publish_date = "",
        purchase_links = [],
        price = "",
        us_price = "",
    } = props;

    return (
        <>
            <div className={style.secondContentItem}>
                <div className={style.details}>
                    {
                        author_name !== "" && (
                            <DetailItem 
                                icon="Circleuser" 
                                label={`Author: ${author_name}`} 
                            />
                        )
                    }
                    {
                        format !== "" && (
                            <DetailItem 
                                icon="Document" 
                                label={`Format: ${format}`} 
                            />
                        )
                    }
                    {
                        isArray(available) && available.length > 0 && (
                            <DetailItem 
                                icon="Headphone" 
                                label="Also available on:"
                            >
                                {
                                    isArray(available) && available.map(({ url, label }, index) => (
                                        <Link to={url} key={index}>
                                            {label}
                                            {index < available.length - 1 ? "," : ""}
                                        </Link>
                                    ))
                                }
                            </DetailItem>
                        )
                    }
                    {
                        isbn !== "" && (
                            <DetailItem 
                                icon="Barcode" 
                                label={`ISBN: ${isbn}`} 
                            />
                        )
                    }
                    {
                        publisher !== "" && (
                            <DetailItem 
                                icon="Building" 
                                label={`Publisher: ${publisher}`} 
                            />
                        )
                    }
                    {
                        publish_date !== "" && (
                            <DetailItem
                                icon="Calendar"
                                label={`Date Published: ${dateTime(publish_date, "MMM DD, YYYY")}`}
                            />
                        )
                    }
                    {
                        pages !== "" && (
                            <DetailItem 
                                icon="Layergroup" 
                                label={`Number of pages: ${pages}`} 
                            />
                        )
                    }
                    {
                        dimension !== "" && (
                            <DetailItem 
                                icon="Spikes" 
                                label={`Dimensions: ${dimension}`} 
                            />
                        )
                    }
                </div>
            </div>
            <div className={style.thirdContentItem}>
                <div className={style.buttons}>
                    {
                        isArray(purchase_links) && purchase_links.length > 0 && purchase_links.map((item, index) => (
                            <PurchaseButton key={`PurchaseButton_${index}`} uk_price={price} us_price={us_price} data={item} />
                        ))
                    }
                </div>
            </div>
        </>
    );
}
